"use strict";

var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.COMMON_PROPS = exports.COMMON_ASYNC_PROPS = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _reactSelect = require("react-select");

var _utils = require("./utils");

var _excluded = ["placeholder", "singleValue", "control", "valueContainer", "clearIndicator", "dropdownIndicator", "menuPortal", "multiValue", "multiValueLabel", "multiValueRemove"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context6, _context7; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty2(_context6 = ownKeys(Object(source), !0)).call(_context6, function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty2(_context7 = ownKeys(Object(source))).call(_context7, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var debounce = require("debounce-promise");

var COMMON_PROPS = ["name", "autoFocus", "inputValue", "filterOption", "isClearable", "isDisabled", "isMulti", "isSearchable", "onMenuOpen", "onMenuClose", "defaultValue", "openMenuOnClick", "options", "placeholder", "value", "noOptionsMessage", "menuPlacement", "menuPosition", "maxMenuHeight", "onInputChange", "isLoading", "onMenuScrollToTop", "onMenuScrollToBottom", "isOptionDisabled"];
exports.COMMON_PROPS = COMMON_PROPS;
var COMMON_ASYNC_PROPS = ["isLoading", "onInputChange", "defaultOptions", "loadOptions", "cacheOptions", "debounceDelay"];
exports.COMMON_ASYNC_PROPS = COMMON_ASYNC_PROPS;

var SelectUtils = /*#__PURE__*/function () {
  function SelectUtils() {
    var _this = this;

    (0, _classCallCheck2["default"])(this, SelectUtils);
    (0, _defineProperty2["default"])(this, "getPropsForType", function (props, type) {
      if (type === "select") {
        return _this.getPropsForSelect(props);
      }

      if (type === "creatable") {
        return _this.getPropsForCreatableSelect(props);
      }

      if (type === "async") {
        return _this.getPropsForAsyncSelect(props);
      }

      if (type === "async-creatable") {
        return _this.getPropsForAsyncCreatableSelect(props);
      }

      return null;
    });
    (0, _defineProperty2["default"])(this, "getPropsForSelect", function (props) {
      var _context;

      return _utils.gatherConditionalProps.apply(void 0, (0, _concat["default"])(_context = [props]).call(_context, COMMON_PROPS));
    });
    (0, _defineProperty2["default"])(this, "getPropsForCreatableSelect", function (props) {
      var _context2;

      return _utils.gatherConditionalProps.apply(void 0, (0, _concat["default"])(_context2 = [props]).call(_context2, COMMON_PROPS, ["onCreateOption", "formatCreateLabel"]));
    });
    (0, _defineProperty2["default"])(this, "getLoadOptions", function (_ref) {
      var loadOptions = _ref.loadOptions,
          debounceDelay = _ref.debounceDelay;
      var delayInt = (0, _parseInt2["default"])(debounceDelay, 10); // eslint-disable-next-line no-restricted-globals

      var delay = !isNaN(delayInt) && delayInt >= 0 ? debounceDelay : 0;

      if (typeof loadOptions === "function") {
        return debounce(loadOptions, delay);
      }

      return undefined;
    });
    (0, _defineProperty2["default"])(this, "getFilterOption", function (props, type) {
      if (type === "async" || type === "async-creatable") {
        return {
          filterOption: function filterOption(options) {
            return options;
          }
        };
      }

      if (props.filterConfig && (0, _keys["default"])(props.filterConfig).length > 0) {
        return {
          filterOption: (0, _reactSelect.createFilter)(props.filterConfig)
        };
      }

      return {
        filterOption: (0, _reactSelect.createFilter)({
          ignoreCase: true,
          ignoreAccents: true,
          trim: true,
          matchFrom: "any",
          stringify: function stringify(option) {
            return "".concat(option.label);
          }
        })
      };
    });
    (0, _defineProperty2["default"])(this, "getNoOptionsMessage", function (_ref2, type) {
      var _noOptionsMessage = _ref2.noOptionsMessage;

      if (type === "async" || type === "async-creatable") {
        if (_noOptionsMessage && (0, _utils.isFunction)(_noOptionsMessage)) {
          return {
            noOptionsMessage: function noOptionsMessage(inputProps) {
              var _context3;

              if (!(0, _trim["default"])(_context3 = inputProps.inputValue).call(_context3)) {
                return null;
              }

              return _noOptionsMessage(inputProps);
            }
          };
        }

        return {
          noOptionsMessage: function noOptionsMessage(_ref3) {
            var inputValue = _ref3.inputValue;
            return (0, _trim["default"])(inputValue).call(inputValue) ? "No options" : null;
          }
        };
      }

      return _noOptionsMessage || {};
    });
    (0, _defineProperty2["default"])(this, "getMenuPortalTarget", function (props) {
      if (props.menuPosition === "fixed") {
        return {
          menuPortalTarget: document.body
        };
      }

      return {};
    });
    (0, _defineProperty2["default"])(this, "getOverriddenStyles", function (fn, state) {
      if ((0, _utils.isFunction)(fn)) {
        return fn.call(null, state);
      }

      return {};
    });
    (0, _defineProperty2["default"])(this, "getRestStyles", function (rest) {
      var styleKeys = (0, _keys["default"])(rest);
      var restNewStyles = {};
      (0, _forEach["default"])(styleKeys).call(styleKeys, function (styleKey) {
        var styleFn = rest[styleKey];

        restNewStyles[styleKey] = function (base, state) {
          return _objectSpread(_objectSpread({}, base), styleFn(state) || {});
        };
      });
      return restNewStyles;
    });
    (0, _defineProperty2["default"])(this, "getSelectStyles", function (styles) {
      var targetHeight = 32;

      var _ref4 = styles || {},
          _ref4$placeholder = _ref4.placeholder,
          _placeholder = _ref4$placeholder === void 0 ? null : _ref4$placeholder,
          _ref4$singleValue = _ref4.singleValue,
          _singleValue = _ref4$singleValue === void 0 ? null : _ref4$singleValue,
          _ref4$control = _ref4.control,
          _control = _ref4$control === void 0 ? null : _ref4$control,
          _ref4$valueContainer = _ref4.valueContainer,
          _valueContainer = _ref4$valueContainer === void 0 ? null : _ref4$valueContainer,
          _ref4$clearIndicator = _ref4.clearIndicator,
          _clearIndicator = _ref4$clearIndicator === void 0 ? null : _ref4$clearIndicator,
          _ref4$dropdownIndicat = _ref4.dropdownIndicator,
          _dropdownIndicator = _ref4$dropdownIndicat === void 0 ? null : _ref4$dropdownIndicat,
          _ref4$menuPortal = _ref4.menuPortal,
          _menuPortal = _ref4$menuPortal === void 0 ? null : _ref4$menuPortal,
          _ref4$multiValue = _ref4.multiValue,
          _multiValue = _ref4$multiValue === void 0 ? null : _ref4$multiValue,
          _ref4$multiValueLabel = _ref4.multiValueLabel,
          _multiValueLabel = _ref4$multiValueLabel === void 0 ? null : _ref4$multiValueLabel,
          _ref4$multiValueRemov = _ref4.multiValueRemove,
          _multiValueRemove = _ref4$multiValueRemov === void 0 ? null : _ref4$multiValueRemov,
          restStyles = (0, _objectWithoutProperties2["default"])(_ref4, _excluded);

      return _objectSpread({
        placeholder: function placeholder(base, state) {
          return _objectSpread(_objectSpread({}, base), {}, {
            color: "#adb5bd"
          }, _this.getOverriddenStyles(_placeholder, state));
        },
        singleValue: function singleValue(base, state) {
          return _objectSpread(_objectSpread({}, base), {}, {
            color: "#495057"
          }, _this.getOverriddenStyles(_singleValue, state));
        },
        control: function control(base, state) {
          return _objectSpread(_objectSpread({}, base), {}, {
            minHeight: "initial"
          }, _this.getOverriddenStyles(_control, state));
        },
        valueContainer: function valueContainer(base, state) {
          return _objectSpread(_objectSpread({}, base), {}, {
            minHeight: "".concat(targetHeight - 1 - 1, "px"),
            padding: "0 8px"
          }, _this.getOverriddenStyles(_valueContainer, state));
        },
        clearIndicator: function clearIndicator(base, state) {
          return _objectSpread(_objectSpread({}, base), {}, {
            padding: "".concat((targetHeight - 20 - 1 - 1) / 2, "px")
          }, _this.getOverriddenStyles(_clearIndicator, state));
        },
        dropdownIndicator: function dropdownIndicator(base, state) {
          return _objectSpread(_objectSpread({}, base), {}, {
            padding: "".concat((targetHeight - 20 - 1 - 1) / 2, "px")
          }, _this.getOverriddenStyles(_dropdownIndicator, state));
        },
        menuPortal: function menuPortal(base, state) {
          return _objectSpread(_objectSpread({}, base), {}, {
            zIndex: 1070
          }, _this.getOverriddenStyles(_menuPortal, state));
        },
        multiValue: function multiValue(base, state) {
          return _objectSpread(_objectSpread({}, base), {}, {
            backgroundColor: "#e9ecef",
            color: state.isDisabled ? "#6c757d" : base.color
          }, _this.getOverriddenStyles(_multiValue, state));
        },
        multiValueLabel: function multiValueLabel(base, state) {
          return _objectSpread(_objectSpread({}, base), {}, {
            fontSize: "11px",
            color: "inherit"
          }, _this.getOverriddenStyles(_multiValueLabel, state));
        },
        multiValueRemove: function multiValueRemove(base, state) {
          return _objectSpread(_objectSpread({}, base), {}, {
            color: "#737373",
            ":hover": {
              color: "#000",
              backgroundColor: "inherit"
            }
          }, _this.getOverriddenStyles(_multiValueRemove, state));
        }
      }, _this.getRestStyles(restStyles) || {});
    });
  }

  (0, _createClass2["default"])(SelectUtils, [{
    key: "getPropsForAsyncSelect",
    value: function getPropsForAsyncSelect(props) {
      var _context4;

      var asyncProps = _utils.gatherConditionalProps.apply(void 0, (0, _concat["default"])(_context4 = [props]).call(_context4, COMMON_PROPS, COMMON_ASYNC_PROPS));

      asyncProps.loadOptions = this.getLoadOptions(asyncProps);
      return asyncProps;
    }
  }, {
    key: "getPropsForAsyncCreatableSelect",
    value: function getPropsForAsyncCreatableSelect(props) {
      var _context5;

      var asyncProps = _utils.gatherConditionalProps.apply(void 0, (0, _concat["default"])(_context5 = [props]).call(_context5, COMMON_PROPS, COMMON_ASYNC_PROPS, ["onCreateOption", "formatCreateLabel"]));

      asyncProps.loadOptions = this.getLoadOptions(asyncProps);
      return asyncProps;
    }
  }]);
  return SelectUtils;
}();

exports["default"] = SelectUtils;